import {
  CURRENT_CHANNEL,
  CHANNEL_LIST,
  CURRENT_NEWS,
  NEWS_LIST
} from '../mutation-types.js'

const state = {
  currentChannel: {},
  channelList: [],
  currentNews: {},
  newsList: []
}

const mutations = {
  [CURRENT_CHANNEL] (state, newData) {
    state.currentChannel = newData
  },
  [CHANNEL_LIST] (state, newData) {
    state.channelList = newData
  },
  [CURRENT_NEWS] (state, newData) {
    state.currentNews = newData
  },
  [NEWS_LIST] (state, newData) {
    state.newsList = newData
  }
}

export default {
  state,
  mutations
}
